var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            {
              staticClass: "pt-2 border-top",
              attrs: { "vs-offset": "1", "vs-lg": "11", "vs-type": "flex" }
            },
            [
              _c(
                "vs-chip",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Fecha de actualización del Expediente",
                      expression: "'Fecha de actualización del Expediente'"
                    }
                  ],
                  staticClass: "mr-4"
                },
                [
                  _c("vs-avatar", { attrs: { icon: "date_range" } }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("dateFormat")(_vm.file.fechaActualizacion)
                      ) +
                      " "
                  )
                ],
                1
              ),
              _c(
                "vs-chip",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Fecha de creación del expediente",
                      expression: "'Fecha de creación del expediente'"
                    }
                  ],
                  staticClass: "mr-4"
                },
                [
                  _c("vs-avatar", { attrs: { icon: "date_range" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("dateFormat")(_vm.file.fechaCreacion)) +
                      " "
                  )
                ],
                1
              ),
              _vm.file.fechaEmision
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Fecha del documento",
                          expression: "'Fecha del documento'"
                        }
                      ],
                      staticClass: "mr-4"
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "event", color: "#ff9f43" }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("dateFormat")(_vm.file.fechaEmision)) +
                          " "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.file.numeroInt && !_vm.isAguasAndinas
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Número de documento",
                          expression: "'Número de documento'"
                        }
                      ],
                      staticClass: "mr-3"
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "tag", color: "#ff9f43" }
                      }),
                      _vm._v(" " + _vm._s(_vm.file.numeroInt) + " ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.file.numeroInt && _vm.isAguasAndinas
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Número de documento",
                          expression: "'Número de documento'"
                        }
                      ],
                      staticClass: "mr-3"
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "tag", color: "#003287" }
                      }),
                      _vm._v(" " + _vm._s(_vm.file.numeroInt) + " ")
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isUseExternalForm &&
              (_vm.file.emisorSucursalDireccion ||
                _vm.file.emisorCentroCostoNombre)
                ? _c(
                    "vs-chip",
                    { staticClass: "mr-3" },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "description", color: "#ff9f43" }
                      }),
                      _vm.file.emisorSucursalDireccion
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "" + _vm.file.emisorSucursalDireccion,
                                  expression:
                                    "`${file.emisorSucursalDireccion}`"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("truncate")(
                                      _vm.file.emisorSucursalDireccion,
                                      20
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e(),
                      !_vm.file.emisorSucursalDireccion
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "" + _vm.file.emisorCentroCostoNombre,
                                  expression:
                                    "`${file.emisorCentroCostoNombre}`"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("truncate")(
                                      _vm.file.emisorCentroCostoNombre || "",
                                      20
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.file.claseMercadoPublico === "ext" && !_vm.isAguasAndinas
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Documento externo",
                          expression: "'Documento externo'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "primary", transparent: "" }
                    },
                    [_vm._v(" externo ")]
                  )
                : _vm._e(),
              _vm.file.claseMercadoPublico === "int" && !_vm.isAguasAndinas
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Documento interno",
                          expression: "'Documento interno'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "primary", transparent: "" }
                    },
                    [_vm._v(" interno ")]
                  )
                : _vm._e(),
              _vm.file.claseMercadoPublico === "numInt" && !_vm.isAguasAndinas
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Numeración Interna",
                          expression: "'Numeración Interna'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { transparent: "", color: "primary" }
                    },
                    [_vm._v(" num. interna ")]
                  )
                : _vm._e(),
              _vm.file.claseMercadoPublico === "numOf" && !_vm.isAguasAndinas
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Numeración Oficina de Partes",
                          expression: "'Numeración Oficina de Partes'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "primary", transparent: "" }
                    },
                    [_vm._v(" num. oficial ")]
                  )
                : _vm._e(),
              _vm.file.enCopia === "SI"
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Estoy en copia",
                          expression: "'Estoy en copia'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "success", transparent: "" }
                    },
                    [_vm._v(" copia ")]
                  )
                : _vm._e(),
              _vm.file.enResponsable === "SI" && _vm.onGeneralFiles
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Soy destinatario/responsable",
                          expression: "'Soy destinatario/responsable'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "danger", transparent: "" }
                    },
                    [_vm._v(" responsable ")]
                  )
                : _vm._e(),
              _vm.file.enGrupo === "SI"
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Estoy en grupo",
                          expression: "'Estoy en grupo'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "danger", transparent: "" }
                    },
                    [_vm._v(" en grupo ")]
                  )
                : _vm._e(),
              _vm.file.transporteViaTransporteCodigoTransporte === 1 &&
              !_vm.isAguasAndinas
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Acompaña físico",
                          expression: "'Acompaña físico'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "#343a40", transparent: "" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "description" } }),
                      _vm._v(" físico ")
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            {
              staticClass: "pt-2",
              attrs: { "vs-offset": "1", "vs-lg": "11", "vs-type": "flex" }
            },
            [
              _vm.file.estadoCodigoEstadoComprador === 1
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Es Documento Madre",
                          expression: "'Es Documento Madre'"
                        }
                      ],
                      staticClass: "mr-3"
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "supervisor_account", color: "#8633FF" }
                      }),
                      _vm._v(" Madre ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.file.estadoCodigoEstadoComprador === 0
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Es Documento Hijo",
                          expression: "'Es Documento Hijo'"
                        }
                      ],
                      staticClass: "mr-3"
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "child_friendly", color: "#8633FF" }
                      }),
                      _vm._v(" Hijo ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.file.plazo > 0
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Adhesiones",
                          expression: "'Adhesiones'"
                        }
                      ],
                      staticClass: "mr-3"
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "thumb_up", color: "#02A52A" }
                      }),
                      _vm._v(" " + _vm._s(_vm.file.plazo) + " ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAguasAndinas && _vm.responsible && _vm.onPendingFiles
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Responsable",
                          expression: "'Responsable'"
                        }
                      ],
                      staticClass: "mr-4"
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "person", color: "#FF0000" }
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.responsible.destinoListaNombre) + " "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAguasAndinas && !_vm.onGeneralFiles && _vm.onPendingFiles
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Para conocimiento",
                          expression: "'Para conocimiento'"
                        }
                      ],
                      attrs: { color: "info", transparent: "" }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { color: "#ff9f43", icon: "book" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAguasAndinas &&
              _vm.responsible &&
              !_vm.onGeneralFiles &&
              _vm.file.receptorTelefono == "1"
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Requiere respuesta",
                          expression: "'Requiere respuesta'"
                        }
                      ],
                      attrs: { color: "info", transparent: "" }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { color: "orange", icon: "apartment" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAguasAndinas && _vm.file.despachoCodigo
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Empresa",
                          expression: "'Empresa'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { "data-cy": "company-code" }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "event", color: "#FF0000" }
                      }),
                      _vm._v(" " + _vm._s(_vm.file.despachoCodigo) + " ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAguasAndinas && _vm.file.fechaVencimiento
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Fecha de vencimiento",
                          expression: "'Fecha de vencimiento'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { "data-cy": "expiration-date" }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "event", color: "#FF0000" }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("dateFormat")(_vm.file.fechaVencimiento)
                          ) +
                          " "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAguasAndinas && _vm.theme && _vm.onPendingFiles
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Tema",
                          expression: "'Tema'"
                        }
                      ],
                      staticClass: "mr-4"
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "info", color: "#FF0000" }
                      }),
                      _vm._v(" " + _vm._s(_vm.theme.label) + " ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.file.transportePuertoTipo == 1 && !_vm.isAguasAndinas
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Archivo privado",
                          expression: "'Archivo privado'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "warning", transparent: "" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "lock" } }),
                      _vm._v(" privado ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.file.transportePuertoTipo == 2 && !_vm.isAguasAndinas
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Archivo reservado",
                          expression: "'Archivo reservado'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "warning", transparent: "" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "description" } }),
                      _vm._v(" reservado ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.file.transportePuertoTipo == 0 && !_vm.isAguasAndinas
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Archivo público",
                          expression: "'Archivo público'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "warning", transparent: "" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "lock" } }),
                      _vm._v(" público ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.file.enviadoOpentText && _vm.file.enviadoOpenText === "Y"
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Enviado a Librería",
                          expression: "'Enviado a Librería'"
                        }
                      ],
                      staticClass: "mr-3",
                      attrs: { color: "danger", transparent: "" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "trending_up" } }),
                      _vm._v(" enviado ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.file.receptorContactoNombre
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Oficina que numeró o tramitó el documento",
                          expression:
                            "'Oficina que numeró o tramitó el documento'"
                        }
                      ],
                      attrs: { color: "info", transparent: "" }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { color: "#ff9f43", icon: "apartment" }
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.file.receptorContactoNombre) + " "
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }